import { type Resource } from 'i18next'
import { DEMO_DEALER_ID, ESP_ROOFING_ID, FAMILY_HERITAGE_ID } from '@terros/common'

export const LANGUAGE_RESOURCES: Resource = {
  en: {
    translation: {
      Archive: 'Archive',
      'Archive action?': 'Archive action?',
      Cancel: 'Cancel',
      'Archiving it will also remove it from these pre-hook configurations:':
        'Archiving it will also remove it from these pre-hook configurations:',
      'This action is selected as a pre-hook by other actions.':
        'This action is selected as a pre-hook by other actions.',
      'You have {{count}} videos, but you {{need}} {{total}}_zero': 'You have no videos, but you {{need}} {{total}}',
      'You have {{count}} videos, but you {{need}} {{total}}_one':
        'You have {{count}} video, but you {{need}} {{total}}',
      'You have {{count}} videos, but you {{need}} {{total}}_other':
        'You have {{count}} videos, but you {{need}} {{total}}',
      "You cannot change this event's time or duration because you do not have the Manage Closer Availability Restrictions permission. Ask an admin for access.":
        "You cannot change this event's time or duration because you do not have the Manage Closer Availability Restrictions permission. Ask an admin for access.",
    },
  },
  [`en-${FAMILY_HERITAGE_ID}`]: {
    translation: {
      Pitch: 'Demo',
      Pitches: 'Demos',
      'Is this a pitch?': 'Is this a demo?',
      Manager: 'Leader',
      "'Days Since Widget' displays the percentage of your team members who haven't performed the chosen activity within that selected timeframe. For example, setting 'Demo' to '10 days' shows you the percentage of your team that hasn't made a demo in the last 10 days.": `'Days Since Widget' displays the percentage of your team members who haven't performed the chosen
        activity within that selected timeframe. For example, setting 'Demo' to '10 days' shows you the percentage of your team that hasn't made a demo in the last 10 days.`,
      'My Manager': 'My Leader',
      'My Other Managers': 'My Other Leaders',
      'This property was listed as Do Not Knock. Please do not try to contact anyone at this location. Reach out to your manager or an admin for further questions.':
        'This property was listed as Do Not Knock. Please do not try to contact anyone at this location. Reach out to your leader or an admin for further questions.',
      'Manager Comments': 'Leader Comments',
      Management: 'Leadership',
      "This team doesn't have a manager": "This team doesn't have a leader",
      'We recommend no more than 2 managers per team. Consider adding a sub team':
        'We recommend no more than 2 leaders per team. Consider adding a sub team',
      'No manager assigned': 'No leader assigned',
      'Primary manager': 'Primary leader',
      'Select a manager': 'Select a leader',
      'Pitch Goal': 'Demo Goal',
      'pitches/day': 'demos/day',
      '{{goal}} pitches': '{{goal}} demos',
      'Is this a phone or a door pitch?': 'Is this a phone or a door demo?',
      pitch: 'demo',
      'Key words are highlighted in pitch transcripts': 'Key words are highlighted in demo transcripts',
      'No Current Pitch Scorecards': 'No Current Demo Scorecards',
      'Create Pitch Scorecard': 'Create Demo Scorecard',
      'This pitch scorecard will be used as the default for pitch recordings':
        'This demo scorecard will be used as the default for demo recordings',
      'Set as default pitch scorecard': 'Set as default demo scorecard',
      'Always a Pitch': 'Always a Demo',
      'Never a Pitch': 'Never a Demo',
      'Whether the contact is a pitch': 'Whether the contact is a demo',
      'Example: You need a minimum of 1 Lead to 4 Pitches or 25% Leads':
        'Example: You need a minimum of 1 Lead to 4 Demos or 25% Leads',
      'Pitch only': 'Demo only',
      'Select Manager': 'Select Leader',
      'Please select a manager': 'Please select a leader',
      "Tap the button below to begin recording your pitch. When you're finished, tap Submit to upload your recording. Be sure you are in a public place while recording. If you want to record in a private place, you must ask for permission.":
        "Tap the button below to begin recording your demo. When you're finished, tap Submit to upload your recording. Be sure you are in a public place while recording. If you want to record in a private place, you must ask for permission.",
      'Interview with {{manager}}': 'Interview with {{leader}}',
      'Shadow with {{manager}}': 'Shadow with {{leader}}',
      'A qualifier is a secondary metric that must be met in order to receive points for the pitch':
        'A qualifier is a secondary metric that must be met in order to receive points for the demo',
      'Use Pitch Qualifier': 'Use Demo Qualifier',
      'Participant must have 1 {{name}} per {{count}} pitches to receive points.':
        'Participant must have 1 {{name}} per {{count}} demos to receive points.',
      'Pitch Qualifier': 'Demo Qualifier',
      'Pitches/wk': 'Demos/wk',
      'How much money do you make per {{stageName}}?': 'What is the average gap per {{stageName}}?',
      'How much income do you want to generate this quarter?': 'What is your gap goal for this quarter?',
    },
  },
  [`en-${ESP_ROOFING_ID}`]: {
    translation: {
      Pitch: 'Conversation',
      Pitches: 'Conversations ',
      'Is this a pitch?': 'Is this a conversation?',
      "'Days Since Widget' displays the percentage of your team members who haven't performed the chosen activity within that selected timeframe. For example, setting 'Conversation' to '10 days' shows you the percentage of your team that hasn't made a demo in the last 10 days.": `'Days Since Widget' displays the percentage of your team members who haven't performed the chosen
        activity within that selected timeframe. For example, setting 'Conversation' to '10 days' shows you the percentage of your team that hasn't made a conversation in the last 10 days.`,
      'Pitch Goal': 'Conversation Goal',
      'pitches/day': 'conversations/day',
      '{{goal}} pitches': '{{goal}} conversations',
      'Is this a phone or a door pitch?': 'Is this a phone or a door conversation?',
      pitch: 'conversation',
      'Key words are highlighted in pitch transcripts': 'Key words are highlighted in conversation transcripts',
      'No Current Pitch Scorecards': 'No Current Conversation Scorecards',
      'Create Pitch Scorecard': 'Create Conversation Scorecard',
      'This pitch scorecard will be used as the default for pitch recordings':
        'This conversation scorecard will be used as the default for conversation recordings',
      'Set as default pitch scorecard': 'Set as default conversation scorecard',
      'Always a Pitch': 'Always a Conversation',
      'Never a Pitch': 'Never a Conversation',
      'Whether the contact is a pitch': 'Whether the contact is a conversation',
      'Example: You need a minimum of 1 Lead to 4 Pitches or 25% Leads':
        'Example: You need a minimum of 1 Lead to 4 Conversations or 25% Leads',
      'Pitch only': 'Conversation only',
      "Tap the button below to begin recording your pitch. When you're finished, tap Submit to upload your recording. Be sure you are in a public place while recording. If you want to record in a private place, you must ask for permission.":
        "Tap the button below to begin recording your conversation. When you're finished, tap Submit to upload your recording. Be sure you are in a public place while recording. If you want to record in a private place, you must ask for permission.",
      'A qualifier is a secondary metric that must be met in order to receive points for the pitch':
        'A qualifier is a secondary metric that must be met in order to receive points for the conversation',
      'Use Pitch Qualifier': 'Use Conversation Qualifier',
      'Participant must have 1 {{name}} per {{count}} pitches to receive points.':
        'Participant must have 1 {{name}} per {{count}} conversations to receive points.',
      'Pitch Qualifier': 'Conversation Qualifier',
      'Pitches/wk': 'Conversations/wk',
    },
  },
  [`en-${DEMO_DEALER_ID}`]: {
    translation: {
      Pitch: 'Up',
      Pitches: 'Ups',
      'Days Knocked': 'Days Worked',
      'Is this a pitch?': 'Is this an up?',
      "'Days Since Widget' displays the percentage of your team members who haven't performed the chosen activity within that selected timeframe. For example, setting 'Demo' to '10 days' shows you the percentage of your team that hasn't made a demo in the last 10 days.": `'Days Since Widget' displays the percentage of your team members who haven't performed the chosen
        activity within that selected timeframe. For example, setting 'Up' to '10 days' shows you the percentage of your team that hasn't made an up in the last 10 days.`,
      'Pitch Goal': 'Up Goal',
      'pitches/day': 'ups/day',
      '{{goal}} pitches': '{{goal}} ups',
      'Is this a phone or a door pitch?': 'Is this a phone or a door up?',
      pitch: 'up',
      'Key words are highlighted in pitch transcripts': 'Key words are highlighted in up transcripts',
      'No Current Pitch Scorecards': 'No Current Up Scorecards',
      'Create Pitch Scorecard': 'Create Up Scorecard',
      'This pitch scorecard will be used as the default for pitch recordings':
        'This up scorecard will be used as the default for up recordings',
      'Set as default pitch scorecard': 'Set as default up scorecard',
      'Always a Pitch': 'Always an Up',
      'Never a Pitch': 'Never an Up',
      'Whether the contact is a pitch': 'Whether the contact is an up',
      'Example: You need a minimum of 1 Lead to 4 Pitches or 25% Leads':
        'Example: You need a minimum of 1 Lead to 4 Ups or 25% Leads',
      'Pitch only': 'Up only',
      "Tap the button below to begin recording your pitch. When you're finished, tap Submit to upload your recording. Be sure you are in a public place while recording. If you want to record in a private place, you must ask for permission.":
        "Tap the button below to begin recording your up. When you're finished, tap Submit to upload your recording. Be sure you are in a public place while recording. If you want to record in a private place, you must ask for permission.",
      'A qualifier is a secondary metric that must be met in order to receive points for the pitch':
        'A qualifier is a secondary metric that must be met in order to receive points for the up',
      'Use Pitch Qualifier': 'Use Up Qualifier',
      'Participant must have 1 {{name}} per {{count}} pitches to receive points.':
        'Participant must have 1 {{name}} per {{count}} ups to receive points.',
      'Pitch Qualifier': 'Up Qualifier',
      'Pitches/wk': 'Ups/wk',
    },
  },
  ['en-Recruiting']: {
    translation: {
      Input: 'Recruit Pipeline',
      Output: 'Rep Journey',
      'Period to Date': 'Production To Date',
      'Input To Date': 'Production To Date',
      'Output To Date': 'Production To Date',
      'Input Insights': 'Recruit Pipeline Insights',
      'Output Insights': 'Rep Journey Insights',
      Hustle: 'Recruit Pipeline',
      Results: 'Rep Journey',
    },
  },
}
